<template>
  <div class="collectCenter clearfix">
    <div class="titleBox">
      <h2>快速清单</h2>
      <p>打上星星标记的商品都在这里 ~</p>
    </div>
    <div class="searchBox">
      <div class="box">
        <div class="form-group m-0">
          <label>产品名称</label>
          <input @input="initData(true)" v-model="keywordVal" type="text" class="form-control">
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>品牌</label>
          <select v-model="pinpai" class="form-control">
            <option></option>
            <option v-for="(app,index) in pinpaiArr" :key="index" :value="app.id">{{app.name}}</option>
          </select>
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>分类</label>
          <select v-model="fenlei" class="form-control">
            <option></option>
            <option v-for="(app,index) in fenleiArr" :key="index" :value="app.id">{{app.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="!intLoading" class="liebiaoBox">
      <table class="table">
        <thead class="thead-light">
        <tr>
          <th scope="col">名称</th>
          <th scope="col">价格</th>
          <th scope="col">品牌</th>
          <th scope="col">分类</th>
          <th scope="col text-right" style="text-align: right">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="app in data" :key="app.id">
          <td @click.self="showModelBox('product',app.id)" class="cursor" scope="row">
            {{app.name}}
          </td>
          <td class="text-danger">
            ￥{{app.priceB}}
          </td>
          <td @click.self="showModelBox('product',app.id)" class="cursor">
            {{app.brandName}}
          </td>
          <td @click.self="showModelBox('product',app.id)" class="cursor">
            {{app.navTitle}}
          </td>
          <td class="text-right">
            <button @click.self="showModelBox('product',app.id)" type="button" class="btn btn-sm btn-outline-success">购买</button>
            <button v-if="!localCart || !localCart.includes(app.id)" @click="makeCart(app.id)" type="button" class="btn btn-sm btn-outline-primary">
              <i style="font-size: 12px;" class="iconfont icon-plus"></i>购物车
            </button>
            <button v-if="localCart && localCart.includes(app.id)" @click="makeCart(app.id)" type="button" class="btn btn-sm btn-outline-danger">
              <i style="font-size: 12px;" class="iconfont icon-jian1"></i>购物车
            </button>
            <button class="btn btn-sm btn-outline-success" @click="collectFun(app.id)">
              <i style="font-size: 12px;" v-if="app.collect" class="iconfont icon-shoucang1 shoucang"></i>
              <i style="font-size: 12px;" v-else class="iconfont icon-shoucang shoucang"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="text-center text-dark">
        <br>
        <br>
        <div v-if='isLoading && page!==1' style="height:19px;" class='dynamicMessage'>
          <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
        </div>
        <div v-if='isNodata' class='dynamicMessage'>
          — 没有更多了 —
        </div>
        <div v-if='isError' class='dynamicMessage'>
          — 请求失败 —
        </div>
        <br>
        <br>
        <br>
        <br>
      </div>
    </div>
    <div class="jiazaiBox" v-if="intLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <transition leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowRightBox" class="rightBoxModel huanchong" @click.self="closeRightBoxFun">
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <component :closeRightBoxFun="closeRightBoxFun" :parameter="parameter" :is="isCompnentElement"></component>
        </transition>
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <span class="guanbiBtn cursor huanchongKuai" @click="closeRightBoxFun(false)">
            <i class="iconfont icon-icon-arrow-right2"></i>
          </span>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import commons from '@/util/commons';
import uiProductContent from '@/components/product/Content';
import uiGroupContent from '@/components/group/Content';

export default {
  name: 'collectCenter',
  mixins: [generalMix],
  data () {
    return {
      isShowRightBox: false,
      isCompnentElement: '',
      parameter: {},
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 筛选
      keywordVal: '',
      pinpaiArr: [],
      pinpai: '',
      fenleiArr: [],
      fenlei: '',
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      allNumber: 0,
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      intLoading: true // 初始化加载
    }
  },
  computed:{
    whereObj() {
      return {
        collect: true,
        page: this.page,
        keyword: this.keywordVal,
        pinpai: this.pinpai,
        fenlei: this.fenlei
      };
    }
  },
  watch:{
    pinpai(newVal,oldVal) {
      this.initData(true);
    },
    fenlei(newVal,oldVal) {
      this.initData(true);
    }
  },
  methods:{
    makeCart(id) {
      if(this.localCart){
        const ob = this.localCart;
        if(this.localCart.includes(id)){
          // 存在 - 剔除
          const obj = ob.filter(app=>{
            return app !== id;
          });
          commons.saveTodos('localCart' + this.localUser.user, obj);
        }else{
          // 不存在 - 追加
          ob.push(id);
          commons.saveTodos('localCart' + this.localUser.user, ob);
        }
      }else{
        commons.saveTodos('localCart' + this.localUser.user, [id]);
      }
      this.saveLocalcartFun({ bool: true });
    },
    closeRightBoxFun() {
      this.isShowRightBox = false;
      this.parameter = {};
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    showModelBox(type,id) {
      this.parameter = {token:id};
      if(type === 'group'){
        this.isCompnentElement = 'ui-group-content';
      }else{
        this.isCompnentElement = 'ui-product-content';
      }
      $('html').addClass('scrollHide');
      this.isShowRightBox = true;
    },
    // 收藏
    collectFun(id) {
      // EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
      resultCommons.apiDealercollectenter(this,{token:id}).then(app=>{
        if(app.state === 200){
          const info = this.data.find(ob=>{
            return ob.id === id;
          });
          info.collect = app.data.bool;
          this.$message.showMsgBox({
            type: 'success',
            content: app.message
          });
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
      });
    },
    // 显示详情
    showProduct(title,imgArr) {
      EventBus.$emit('globalRightBoxFun', { type: 1, obj: { title:title,imgArr:imgArr } });
    },
    // 获取分类导航
    apiGoodsnav() {
      return resultCommons.apiGoodsnav(this, {}).then((ob) => {
        if(ob.state === 200){
          this.pinpaiArr = ob.data.pinpaiArr;
          this.fenleiArr = ob.data.fenleiArr;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message
          });
        }
      });
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = commons.scrollToButton() <= 150;
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          resultCommons.apiGoodslists(that, this.whereObj).then((ob) => {
            console.log(ob, this.page);
          });
        }
      };
    },
    initData(bool = false){
      if(bool){
        this.intLoading = true;
      }
      // 执行搜索
      this.loadingFun(2);
      // 初始化
      this.data = [];
      this.allPage = 1;
      this.page = 1;
      // 不为空
      this.is_empty = false;
      const whereJson = this.whereObj;
      // 执行搜索
      resultCommons.apiGoodslists(this, whereJson).then((ob) => {}).then(app=>{
        if(bool){
          this.intLoading = false;
        }
      });
    }
  },
  components: {
    Multiselect,
    'ui-product-content':uiProductContent,
    'ui-group-content':uiGroupContent
  },
  created() {
    // 标签
    // EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
    this.apiGoodsnav();
    // 主数据
    this.initData(true);
  },
  mounted() {
    // 下拉事件
    this.scroll(this, window);
    $('html').removeClass('scrollHide');
  },
  beforeDestroy() {
    // 清除事件
    window.onscroll = null;
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.collectCenter {
  div.liebiaoBox{
    background: url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    border-radius: 5px;
    overflow: hidden;
    min-height: 90vh;
    width: 100%;
    table{
      table-layout:fixed;
      tr{
        td,th{
          white-space: nowrap; //不换行
          overflow: hidden;//隐藏
          text-overflow: ellipsis;//使用...代替
          &:nth-child(2){
            width: 100px;
          }
          &:nth-child(3){
            width: 150px;
          }
          &:nth-child(4){
            width: 100px;
          }
          &:nth-child(5){
            width: 200px;
          }
        }
      }
    }
  }
  .titleBox {
    margin-top: 30px;
    color: #FFFFFF;
    margin-bottom: 30px;
    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  div.searchBox{
    margin-bottom: 20px;
    display: flex;
    div.box{
      flex: 1;
      margin-right: 15px;
      &:last-child{
        margin: 0;
      }
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    box-shadow: 0 0 6px rgba(0, 0, 0, .2);
    background:#E9ECEF url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    min-height: 100vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
    }
  }
  div.loadingBox{
    margin-bottom: 60px;
    margin-top: 40px;
    div.noDataBox{

    }
  }
}

@media (max-width: 992px) {
  .collectCenter{
    .titleBox {
      margin-top: 30px;
      margin-bottom: 30px;
      color: #FFFFFF;
      p {
        margin: 0;
        color: #999999;
      }
    }
  }
}

@media (max-width: 767px) {
  .collectCenter{
    .titleBox {
      margin-top: 50px;
      text-align: center;
      p{
        padding: 0 15px;
      }
    }
    div.searchBox{
      flex-direction: column;
      div.box{
        margin-right: 0;
        margin-bottom: 10px;
        &:last-child{
          button.btn{
            width: 100%;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/collect/Center.vue